import * as React from 'react';
import styled from 'styled-components';
import LoadingIcon from '../Shared/LoadingIcon';
import { IYadoPagination } from './types';
import t from './locales';

const Container = styled.div`
  text-align: center;
  margin: 4em 0;
`;

const View = styled.a`
  padding: 1em 2em;
  cursor: pointer;
  color: var(--blue600);
  border: 1px solid var(--blue600);
  border-radius: 0.5em;
  &:hover {
    transition: all 0.3s ease;
    color: var(--blue600);
    text-decoration: none;
    background-color: var(--blue100);
  }
`;

interface IProps {
  pagination: IYadoPagination;
  handleNextClick: () => void;
  isLoading: boolean;
}

const YadoPaginationButton: React.FC<IProps> = (props) => {
  const { pagination, handleNextClick, isLoading } = props;
  const { hasNext } = pagination;
  if (!hasNext || handleNextClick == null) { return null; }

  function handleClick(event: React.MouseEvent) {
    event.preventDefault();
    handleNextClick();
  }

  return (
    <Container>
      <View onClick={handleClick} href="#">
        {isLoading ? <LoadingIcon /> : t.seeMore()}
      </View>
    </Container>
  );
}

export default YadoPaginationButton;
